import Message from "./Message";

import makePropsEnumerable from "../utility/MakePropsEnumerable";

const mMessageQueue = new WeakMap();
const mMessagesDefaultType = new WeakMap();
const mMessageDefaultTimeout = new WeakMap();
const mNextMessageId = new WeakMap();

const overrideDefaultTimeoutSentinelValue = -1;

class MessageQueue {
    constructor(defaultMessagesType, defaultTimeout = null) {
        mMessageQueue.set(this, []);
        mNextMessageId.set(this, 0);

        if (defaultMessagesType != null) {
            mMessagesDefaultType.set(this, defaultMessagesType);
        }
        else {
            mMessagesDefaultType.set(this, null);
        }
        
        if ((Number.isInteger(defaultTimeout)) && (defaultTimeout > 0)) {
            mMessageDefaultTimeout.set(this, defaultTimeout);    
        }
        else {
            mMessageDefaultTimeout.set(this, null);
        }
        
    }

    static get timeoutOverrideValue() {
        return overrideDefaultTimeoutSentinelValue;
    }

    get messages() {
        return mMessageQueue.get(this);
    }
    
    get messageCount() {
        return mMessageQueue.get(this).length;
    }

    publishMessage(msgText, msgTimeout = null, msgType = null) {
        let currentMessageId = mNextMessageId.get(this);

        let currentMessageTimeout = mMessageDefaultTimeout.get(this);
        if (Number.isInteger(msgTimeout)) {
            if (msgTimeout > 0) {
                currentMessageTimeout = msgTimeout;
            }
            else if (msgTimeout === overrideDefaultTimeoutSentinelValue) {
                currentMessageTimeout = undefined;
            }
        }

        let currentMessageType = mMessagesDefaultType.get(this);
        if ((typeof msgType === "string") && (msgType.length > 0)) {
            currentMessageType = msgType;
        }
        
        if (currentMessageType == null) {
            throw new TypeError("Cannot publish message: no message type was provided and the default message type is null.");
        }

        let currentMessage = new Message(currentMessageId, currentMessageType, msgText, currentMessageTimeout);

        mMessageQueue.get(this).push(currentMessage);

        mNextMessageId.set(this, currentMessageId + 1);

        return currentMessageId;
    }

    removeMessageById(msgId) {
        let messageQueue = mMessageQueue.get(this);
        let selectedMessageIdx = messageQueue.findIndex(msg => (msg.messageId === msgId));
        if (selectedMessageIdx >= 0) {
            messageQueue.splice(selectedMessageIdx, 1);
        }
    }

    removeMessageAtIdx(msgIdx) {
        let messageQueue = mMessageQueue.get(this);
        if (Number.isInteger(msgIdx) &&
            (msgIdx >= 0) &&
            (msgIdx < messageQueue.length)) {

            messageQueue.splice(msgIdx, 1);
        }
    }

    clearMessages() {
        mMessageQueue.get(this).length = 0;
    }

}

makePropsEnumerable(MessageQueue.prototype, [
    "messages",
    "messageCount"
]);

export default MessageQueue;



//////////////////
// WEBPACK FOOTER
// ./src/models/MessageQueue.js
// module id = saI8
// module chunks = 1